import { ITheme } from "@grassrootly/rn-core";
import { GrassrootlyFonts } from "../fonts";

export const GrassrootlyTheme: ITheme = {
  title: "Grassrootly",
  key: "grassrootly",
  fonts: {
    primary: {
      light: GrassrootlyFonts.EXO2,
      regular: GrassrootlyFonts.EXO2,
      bold: GrassrootlyFonts.EXO2,
    },
    secondary: {
      light: GrassrootlyFonts.EXO2,
      regular: GrassrootlyFonts.EXO2,
      bold: GrassrootlyFonts.EXO2,
    },
    baseSize: 18,
  },
  colors: {
    primary: {
      main: "#34d986",
      light: "#004080",
      dark: "#00264d",
      contrast: "#072331",
    },
    secondary: {
      main: "#203946",
      light: "#81a9bc",
      dark: "#3ec6a4",
      contrast: "#ecf6ec",
    },
    neutralLighter: {
      main: "#000f1e",
      light: "#fdfefd",
      dark: "#bcc4bc",
      contrast: "#ecf6ec",
    },
    neutralDarker: {
      main: "#072331",
      light: "#001a35",
      dark: "#072331",
      contrast: "#000f1e",
    },
    success: {
      main: "#28a745",
      light: "#2cb94c",
      dark: "#23943d",
      contrast: "#ecf6ec",
    },
    warning: {
      main: "#ffc107",
      light: "#ffc71f",
      dark: "#ebb000",
      contrast: "#f2f2f2",
    },
    danger: {
      main: "#dc3545",
      light: "#e04d5b",
      dark: "#d52536",
      contrast: "#ecf6ec",
    },
    info: {
      main: "#17a4ba",
      light: "#1ab8d1",
      dark: "#1594a8",
      contrast: "#ecf6ec",
    },
  },
  grid: {
    breakPoints: {
      s: 320,
      m: 640,
      l: 960,
      xl: 960,
      xxl: 960,
    },
  },
};
